(function (app) {
    app.provider("agentXrefApi", [function () {
        this.$get = ["externalsApiGateway", function (externalsApiGateway) {
            var service = {};

            service.getFigXref = function () {
                return externalsApiGateway.get("/Agents/Users/Arc");
            };

            service.getAcmXref = function () {
                return externalsApiGateway.get("/Agents/Users/Acm");
            };

            service.getParentFigXrefs = function() {
                return externalsApiGateway.get("/Agents/Users/Parents/Arc");
            };

            service.getParentAcmXrefs = function() {
                return externalsApiGateway.get("/Agents/Users/Parents/Acm");
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line